import { formDataRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceGetVendorCategory(params) {
    return await postRequest('categories', params);
}
export async function serviceGetVendorDetail(params) {
    return await postRequest('categories/detail', params);
}
export async function serviceVendorCategoryUpdate(params) {
    return await formDataRequest('categories/update', params);
}
export async function serviceVendorCategoryCreate(params) {
    return await formDataRequest('categories/create', params);
}
